























import Vue from "vue";

export default Vue.extend({
  props: {
    showDividerTop: {
      type: Boolean,
      default: false
    },
    showDividerBottom: {
      type: Boolean,
      default: true
    },
    disableScroll: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleScroll(e: any) {
      const el = this.$refs['modal-mask']
      if (el) {
        (el as any).style.height = '100vh'
      }
      if (this.disableScroll) {
        return e.preventDefault();
      }
    },
  }
});
